import { useEffect, useState } from "react";
import { usePrefersReducedMotion } from "./hooks";

type RotatingRoleProps = {
  roles: readonly string[];
  interval?: number;
};

/**
 * Cycles through role titles with a small fade/slide transition (the swap is
 * driven by React `key`, so the CSS animation replays with no extra state).
 * Shows a single static role under reduced motion.
 */
export default function RotatingRole({
  roles,
  interval = 2600,
}: RotatingRoleProps) {
  const reduce = usePrefersReducedMotion();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (reduce || roles.length < 2) return;
    const id = window.setInterval(
      () => setIndex((i) => (i + 1) % roles.length),
      interval
    );
    return () => window.clearInterval(id);
  }, [reduce, roles.length, interval]);

  return (
    <span className="anim-role">
      <span key={index} className="anim-role__word">
        {roles[index]}
      </span>
      <span className="anim-caret" aria-hidden="true" />
    </span>
  );
}
